<template>
    <div class="vx-card w-full h-auto p-4 bg-white shadow-md">
        <div class="flex vs-row w-full h-full items-center">
            <div class="container w-3/5 lg:w-3/5 h-16 border-right-gray flex items-center">
                <slot name="body"></slot>
            </div>
            <div class="flex justify-start w-2/5 lg:w-2/5 h-16 ">
                <div class="flex items-center justify-center w-2/3 h-full border-right-gray text-center font-bold">
                    <slot name="subtotal"></slot>
                </div>
                <div class="flex items-center justify-center w-1/3 h-full">
                    <slot name="remove">
                        <feather-icon class="cursor-pointer" icon="XIcon" @click="() => $emit('removeItem', true)"></feather-icon>
                    </slot>
                </div>
            </div>
            <div class="container flex w-full">
                <slot name="bottom"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        
    }
}
</script>

<style>
    .border-right-gray {
        border-right: 1px solid #b8c2cc;
    }
</style>
